import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'María G.',
  role: 'Emprendedora Digital',
  quote: 'Empecé sin saber nada de internet y hoy tengo mi propia tienda online. La guía es súper clara y fácil de seguir.',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=face'
}, {
  id: 2,
  name: 'Carlos R.',
  role: 'Padre de familia',
  quote: 'Trabajaba 10 horas por día y no me alcanzaba. Ahora genero ingresos extra desde casa mientras estoy con mi familia.',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face'
}, {
  id: 3,
  name: 'Laura M.',
  role: 'Dueña de negocio local',
  quote: 'Lo mejor es que las estrategias están pensadas para Argentina. No es contenido genérico, realmente funciona acá.',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-slate-50 relative overflow-hidden" data-id="element-83">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-84">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-50 rounded-full blur-3xl opacity-50" data-id="element-85" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-86">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-87">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center px-4 py-1.5 mb-6 text-sm font-semibold text-brand-blue bg-blue-100 rounded-full" data-id="element-88">
            Casos de Éxito
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-3xl md:text-4xl font-heading font-bold text-slate-900" data-id="element-89">
            Más de 200 emprendedores ya dieron el salto digital
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-90">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white rounded-2xl p-8 shadow-soft relative" data-id="element-91">
              <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-slate-100 rotate-180" data-id="element-92" />

              <div className="flex items-center mb-6" data-id="element-93">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-94" />)}
              </div>

              <p className="text-slate-700 text-lg mb-8 relative z-10 italic" data-id="element-95">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center mt-auto" data-id="element-96">
                <img src={testimonial.avatar} alt={`Foto de ${testimonial.name}`} className="w-12 h-12 rounded-full object-cover border-2 border-slate-100" data-id="element-97" />
                <div className="ml-4" data-id="element-98">
                  <h4 className="font-heading font-semibold text-slate-900" data-id="element-99">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-slate-500" data-id="element-100">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}